import { array, object, string } from 'yup';

export const dischargeNoteValidation = () => object({
  diagnosis: array().of(string())
    .when([ 'submit', 'reason_for_discharge' ], {
      is: (submit: string, reasonForDischarge: string) => submit === 'now' && reasonForDischarge !== 'Client did not start treatment',
      then: s => s.required().min(1, 'Add at least one diagnosis'),
      otherwise: s => s.notRequired().nullable()
    }),
  discharge_summary: string().trim().required('Add information about your client that any future providers should know')
});
